import React from "react";
import { Container, Card, Button, Alert } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FaCheckCircle, FaPrint, FaEnvelope } from "react-icons/fa";
import "./OrderForm.css"; // Reusing your existing CSS

const OrderSuccessPage = () => {
  const location = useLocation();
  const orderId = location.state?.orderId; // You'll need to pass this from your form submission

  return (
    <div className="success-page-container">
      <Container className="py-5">
        <Card className="success-card text-center">
          <Card.Body>
            <div className="success-icon">
              <FaCheckCircle />
            </div>
            <h2 className="success-title">Order Submitted Successfully!</h2>
            
            <Alert variant="success" className="success-alert">
              Thank you for your order. {orderId && `Your order ID is: ${orderId}`}
              <br />
              We've sent a confirmation to your email address.
            </Alert>

            <div className="order-summary">
              <h5>Order Summary</h5>
              <p>We'll process your order and contact you if we need any additional information.</p>
              {/* You could add more order details here if you pass them through location.state */}
            </div>

            <div className="success-actions">
             
              
              <Button 
                variant="outline-secondary" 
                className="me-3"
                onClick={() => window.print()}
              >
                <FaPrint className="me-2" />
                Print Receipt
              </Button>
              
              
            </div>

            <div className="success-footer">
              <p className="text-muted">
                Need help? Call us at <a href="tel:+1571 331 2344">571 331 2344</a> or email <a href="mailto:gullate45@gmail.com">gullate45@gmail.com</a>
              </p>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default OrderSuccessPage;